






import { Component, Prop, Vue, Watch } from "vue-property-decorator";

const evt3rdArg = (() => {
  let result: any = false;

  try {
    const arg = Object.defineProperty({}, "passive", {
      get() {
        result = { passive: true };
        return result;
      }
    });

    window.addEventListener("testpassive", arg as EventListener);
    window.removeEventListener("testpassive", arg as EventListener);
  } catch (e) {
    /* */
  }

  return result;
})();

@Component
export default class ScrollLoader extends Vue {
  @Prop() loadOffset!: number;
  @Prop() element!: HTMLElement;

  @Watch("element", { deep: true })
  onElementChanged(newEl?: HTMLElement, oldEl?: HTMLElement) {
    setTimeout(() => {
      if (oldEl) oldEl.removeEventListener("scroll", this.onScroll, evt3rdArg);
      if (newEl) {
        newEl.addEventListener("scroll", this.onScroll, evt3rdArg);

        // these are added for KPI data tables, because the scroll event isn't fired on them, but their ancestors
        if (newEl?.parentNode?.parentNode?.parentNode !== null) {
          newEl?.parentNode?.parentNode?.parentNode.addEventListener("scroll", this.onScroll, evt3rdArg); // (due) invoices grid
        }
        if (newEl?.parentNode?.parentNode?.parentNode?.parentNode !== null) {
          newEl?.parentNode?.parentNode?.parentNode?.parentNode.addEventListener("scroll", this.onScroll, evt3rdArg); // all other grids
        }
      }
    });
  }

  onScroll(ev: Event) {
    const { scrollTop, clientHeight, scrollHeight } = ev && (ev.target as any);
    
    if (scrollTop && scrollHeight && (scrollHeight - clientHeight - scrollTop) < this.loadOffset) {
      this.$emit('offsetReached');
    }
  }

  beforeDestroy() {
    if (this.element) {
      this.element.removeEventListener("scroll", this.onScroll, evt3rdArg);
    }
  }
}
